exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td.td-right { \r\n    text-align: right; \r\n}\r\n\r\np.bold {\r\n    font-weight: 700;\r\n}\r\n\r\n.negotiator-btn {\r\n    width: 100%;\r\n    white-space: nowrap;\r\n    padding: .5em;\r\n    margin-top: .5em;\r\n}\r\n\r\n/* Chrome, Safari, Edge, Opera */\r\ninput::-webkit-outer-spin-button,\r\ninput::-webkit-inner-spin-button {\r\n    -webkit-appearance: none;\r\n    margin: 0;\r\n}\r\n\r\n/* Firefox */\r\ninput[type=number] {\r\n    -moz-appearance: textfield;\r\n}", ""]);

// exports
